export enum ParametrosKey {
    exibirFiltrosColaboradores = 'exibirFiltrosColaboradores',
    permitirBuscaNomeColaboradores = 'permitirBuscaNomeColaboradores',
    permitirBuscaCPFColaboradores = 'permitirBuscaCPFColaboradores',
    permitirBuscaNomeIncrementalColaboradores = 'permitirBuscaNomeIncrementalColaboradores',
    permitirBuscaCPFIncrementalColaboradores = 'permitirBuscaCPFIncrementalColaboradores',
    permitirBuscaVaziaColaboradores = 'permitirBuscaVaziaColaboradores',
    permitirDesativarColaborador = 'permitirDesativarColaborador',
    exibirSaldoCedente = 'exibirSaldoCedente',
    exigirUnidadeCadastroColaborador = 'exigirUnidadeCadastroColaborador',
    labelPersonalizadaMatriculaColaborador = 'labelPersonalizadaMatriculaColaborador',
    labelPersonalizadaCentroCustoColaborador = 'labelPersonalizadaCentroCustoColaborador',
    labelPersonalizadaUnidadeColaborador = 'labelPersonalizadaUnidadeColaborador',
    labelPersonalizadaDepartamentoColaborador = 'labelPersonalizadaDepartamentoColaborador',
    labelPersonalizadaProdutosColaborador = 'labelPersonalizadaProdutosColaborador',
    labelPersonalizadaStatusColaborador = 'labelPersonalizadaStatusColaborador',
    exibirColunaCentroCustoColaboradores = 'exibirColunaCentroCustoColaboradores',
    exibirColunaUnidadeColaboradores = 'exibirColunaUnidadeColaboradores',
    exibirColunaDepartamentoColaboradores = 'exibirColunaDepartamentoColaboradores',
    exibirStatusColaborador = 'exibirStatusColaborador',
    exibirMatriculaColaborador = 'exibirMatriculaColaborador',
    permitirEditarMatriculaColaborador = 'permitirEditarMatriculaColaborador',
    permitirVincularQRCode = 'permitirVincularQRCode',
    perfisPermitidosConviteGestor = 'perfisPermitidosConviteGestor',
    permitirSubmenus = 'permitirSubmenus',
    apenasGestorResponsavelGerenciarGestores = 'apenasGestorResponsavelGerenciarGestores',
    permitirMenus = 'permitirMenus',
    labelPersonalizadaMenuAdministrativo = 'labelPersonalizadaMenuAdministrativo',
    labelPersonalizadaSubmenuGestores = 'labelPersonalizadaSubmenuGestores',
    labelPersonalizadaGestor = 'labelPersonalizadaGestor',
    labelPersonalizadaGestoresCadastrados = 'labelPersonalizadaGestoresCadastrados',
    labelPersonalizadaNomePerfilCadastro = 'labelPersonalizadaNomePerfilCadastro',
    labelPersonalizadaGestores = 'labelPersonalizadaGestores',
    validarLimiteColaboradores = 'validarLimiteColaboradores',
    gestorCadastroInicialColaboradores = 'gestorCadastroInicialColaboradores',
    permitirMenuContexto = 'permitirMenuContexto',
    permitirBuscaNomeGestores = 'permitirBuscaNomeGestores',
    permitirBuscaCPFGestores = 'permitirBuscaCPFGestores',
    permitirBuscaNomeIncrementalGestores = 'permitirBuscaNomeIncrementalGestores',
    permitirBuscaCPFIncrementalGestores = 'permitirBuscaCPFIncrementalGestores',
    permitirBuscaStatusGestores = 'permitirBuscaStatusGestores',
    idadeMinimaColaborador = 'idadeMinimaColaborador',
    permitirAdicionarColaboradorEmLotes = 'permitirAdicionarColaboradorEmLotes',
    permitirVincularQRemLote = 'permitirVincularQRemLote',
    idadeMaximaColaborador = 'idadeMaximaColaborador',
    permitirGerenciarCartoesBeneficio = 'permitirGerenciarCartoesBeneficio',
    cadastroColaboradorEmailObrigatorio = 'cadastroColaboradorEmailObrigatorio',
    cadastroColaboradorTelefoneObrigatorio = 'cadastroColaboradorTelefoneObrigatorio',
    exibirOpcaoVerDetalhes = 'exibirOpcaoVerDetalhes',
    buscarListaColaboradoresInicialmente = 'buscarListaColaboradoresInicialmente',
    exibirFlagAplicativo = 'exibirFlagAplicativo',
    temEndereco = 'temEndereco',
    temInscricaoMunicipal = 'temInscricaoMunicipal',
    temDadoBancario = 'temDadoBancario',
    temContaFlexivel = 'temContaFlexivel',
    temContaSeuValeLog = 'temContaSeuValeLog',
    temContaDespesas = 'temContaDespesas',
    validarPinDestinacaoCredito = 'validarPinDestinacaoCredito',
    permitirValorIncremento = 'permitirValorIncremento',
    permitirCartaoFisico = 'permitirCartaoFisico',
    notaFiscalDetalhada = 'notaFiscalDetalhada',
    textoNotaFiscalDetalhada = 'textoNotaFiscalDetalhada',
    exibirNovaRecarga = 'exibirNovaRecarga'
}
